import { env } from "build/env";
const normalizeHost = hostOrUrl => {
  if (!hostOrUrl) return "";
  const withProtocol = hostOrUrl.includes("://") ? hostOrUrl : "".concat(window.location.protocol, "//").concat(hostOrUrl);
  try {
    return new URL(withProtocol).hostname;
  } catch (_unused) {
    return "";
  }
};
export const configuredTakeawayHost = normalizeHost(env.URL_TAKEAWAY);
export const configuredSwissTakeawayHost = normalizeHost(env.URL_TAKEAWAY_CH) || (configuredTakeawayHost !== null && configuredTakeawayHost !== void 0 && configuredTakeawayHost.endsWith(".com") ? configuredTakeawayHost.replace(/\.com$/, ".ch") : "");
export const shouldAskSwissRedirect = function (store) {
  let {
    enableSwissOrderRedirect = true
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const isSwissStore = (store === null || store === void 0 ? void 0 : store.storeViewOrder) === "miscusi_ch_sv";
  const isCurrentHostSourceTakeaway = configuredTakeawayHost ? window.location.hostname === configuredTakeawayHost : false;
  const hasValidSwissTargetHost = !!configuredSwissTakeawayHost;
  return enableSwissOrderRedirect && isSwissStore && isCurrentHostSourceTakeaway && hasValidSwissTargetHost;
};
export const getSwissRedirectUrl = (store, _ref) => {
  let {
    orderPath,
    orderFromRestaurantPath,
    bookPath,
    bookFromRestaurantPath
  } = _ref;
  const redirectUrl = new URL(window.location.href);
  redirectUrl.hostname = configuredSwissTakeawayHost;
  const storeIdentifier = store === null || store === void 0 ? void 0 : store.ls_store_id;
  const currentPath = window.location.pathname;
  const isOrderFlow = currentPath.startsWith(orderPath) || currentPath.startsWith(orderFromRestaurantPath);
  const isBookingFlow = currentPath.startsWith(bookPath) || currentPath.startsWith(bookFromRestaurantPath);
  if (storeIdentifier) {
    if (isOrderFlow) {
      redirectUrl.pathname = "".concat(orderFromRestaurantPath, "/").concat(storeIdentifier);
    } else if (isBookingFlow) {
      redirectUrl.pathname = "".concat(bookFromRestaurantPath, "/").concat(storeIdentifier);
    }
  }
  if (store !== null && store !== void 0 && store.cps) {
    redirectUrl.searchParams.set("cps", store.cps);
  }
  return redirectUrl.toString();
};